import { createClient } from "@supabase/supabase-js";

const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZreGduaGNja2ptZ3BudWJlcHd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzExOTczNTIsImV4cCI6MjA0Njc3MzM1Mn0.wg0z0anhQ3xYe2A8oNIVDfUlwCTWJbFKMCg8bgU4cN4";
const supabaseUrl = "https://vkxgnhcckjmgpnubepwu.supabase.co";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
